import React, { FC } from 'react';

export const InternalError: FC = () => (
  <div className="grid h-full min-h-screen w-full place-items-center bg-white p-32">
    Something went wrong. <br />
    Please, reload the page
  </div>
);
